import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
import {
    createStrapiMediaUrl,
    ImageModel,
    useAppSelector,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import {
    fetchCompanyInformationThunk,
} from 'shared/lib';

export type ReviewPageState = {
    loaded: boolean
    errors: BaseError[]
    yandexMapReviewLink?: string
    logoImage?: ImageModel
};

const initialState: ReviewPageState = {
    loaded: false,
    errors: [],
};

export const reviewPageSlice = createSlice({
    name: 'reviewPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchCompanyInformationThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.logoImage = {
                        url: createStrapiMediaUrl(response.data.data.logoImage.url),
                    };
                    state.yandexMapReviewLink = response.data.data.yandexMapReviewLink;
                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});

export const useReviewPageState = () => useAppSelector((store) => store.reviewPage);
